export const HOURS_PER_DAY = 24;
export const MINUTES_PER_DAY = HOURS_PER_DAY * 60;
export const TIME_LINE_HEIGHT = 65;
